module.exports = __webpack_public_path__ + "static/img/jx-1.8706d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx-1.png
// module id = 4/ii
// module chunks = 0